export const SEARCH_PAGE_CHUNK_NAME = "s";
export const CATEGORY_PAGE_CHUNK_NAME = "c";
export const BRANDS_PAGE_CHUNK_NAME = "b";
export const BRAND_ERROR_CHUNK_NAME = "nb";
export const PAGE_NOT_FOUND_CHUNK_NAME = "nf";

export const BRAND_ERROR_PATH_MATCHER = "*brand-error*";
export const BRAND_UNAVAILABLE_PATH_MATCHER = "*brand-unavailable*";
export const SEARCH_PAGE_PATH_MATCHER = "(*/)search(/**)";
export const BRANDS_PAGE_PATH_MATCHER = "*/a-to-z-of-brands/cat";
export const CATEGORY_PAGE_PATH_MATCHER = "(*/a-to-z-of-brands/:brand)(**/)cat";
export const PAGE_NOT_FOUND_PATH_MATCHER = "*";
